module.exports = __webpack_public_path__ + "img/headportrait_5_icon.f4637765.png";